import React, { memo } from 'react';
import ProfilePictureAvatarRender from '@sekoia/shared/components/Avatar/ProfilePictureAvatarRender';
import { Box, Typography } from '@mui/material';

type PinAvatarProps = {
  avatarPicUrl: string | undefined;
  name: string;
};

const PinAvatar: React.FC<PinAvatarProps> = (props) => {
  const { avatarPicUrl, name } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <ProfilePictureAvatarRender size={64} pictureUrl={avatarPicUrl} name={name} />
      <Box sx={{ textAlign: 'center', pt: 2, fontSize: 24 }}>
        <Typography variant="h6">{name}</Typography>
      </Box>
    </Box>
  );
};

PinAvatar.displayName = 'PinAvatar';

export default memo(PinAvatar);
